import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Stack, Button} from 'views/components';
import {ChevronLeft, ChevronRight} from 'views/icons';
import {Translate} from 'views/module';

const EventListTitle = (props) => {
  const {
    weekRange,
    handleWeekNavigation,
    loading,
  } = props;

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexDirection={{xs: 'column', sm: 'row'}}>
        <Stack
          spacing={1}
          sx={{
            py: {xs: 1, sm: 2},
          }}
        >
          <Typography
            sx={{
              fontWeight: 300,
              fontStyle: 'light',
              fontSize: '2.0rem',
              lineHeight: '120%',
              letterSpacing: '-2%',
            }}
            align='left'
          >
            <Translate expression={'eventList.title'} />
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '1.0rem',
              lineHeight: '150%',
              letterSpacing: '0%',
            }}
            align='left'
          >
            <Translate expression={'eventList.subtitle'} />
          </Typography>
        </Stack>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          sx={{width: {xs: '100%', sm: 'auto'}, justifyContent: {xs: 'center', sm: 'flex-start'}}}
        >
          <Button
            variant="outlined"
            size="small"
            sx={{minWidth: 'auto', p: 0.5}}
            disabled={loading}
            onClick={(e) => {
              e.stopPropagation();
              handleWeekNavigation(-1);
            }}
          >
            <ChevronLeft />
          </Button>
          <Typography
            variant="body2"
            sx={{
              mx: 1,
              whiteSpace: 'nowrap',
              textAlign: 'center',
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {weekRange}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            sx={{minWidth: 'auto', p: 0.5}}
            disabled={loading}
            onClick={(e) => {
              e.stopPropagation();
              handleWeekNavigation(1);
            }}
          >
            <ChevronRight />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

EventListTitle.propTypes = {
  weekRange: PropTypes.string.isRequired,
  handleWeekNavigation: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default React.memo(EventListTitle);
